import { DropoffPreference } from './constants'

export const deriveDropoffPref = (
  isAdd: boolean,
  loadedMilesMin?: number | null,
  loadedMilesMax?: number | null,
  isSpecificLane?: boolean
): DropoffPreference | undefined => {
  if (isSpecificLane) {
    return DropoffPreference.specificLocation
  }
  if (isAdd) {
    return undefined
  }
  if (loadedMilesMin === null && loadedMilesMax === 100) {
    return DropoffPreference.localHaul
  }
  if (loadedMilesMin === 100 && loadedMilesMax === 300) {
    return DropoffPreference.shortHaul
  }
  if (loadedMilesMin === 300 && loadedMilesMax === null) {
    return DropoffPreference.longHaul
  }
  if (loadedMilesMin === null && loadedMilesMax === null) {
    return DropoffPreference.specificLocation
  }
  return undefined
}
